// React hooks
import { useCallback, useEffect, useState } from "react";
import { useParams } from "react-router-dom";

// API servisi
import { Tenant } from "services/api/tenants/types";
import { getTenantAPI } from "services/api/tenants/api";

// Tipovi i konstante
import { TenantDetailPageCmp, TenantDetailPageProps } from "./types";
import {
  TENANT_DETAIL_PAGE_TITLE,
  TENANT_SEARCH_PAGE_TITLE,
} from "ui/components/PageTitle/consts";
import { BreadcrumbItem } from "ui/components/Breadcrumb/types";

// UI komponente
import { Breadcrumb } from "ui/components/Breadcrumb";
import { PageHeader } from "ui/components/PageHeader";
import { PageTitle } from "ui/components/PageTitle";
import { Loader } from "ui/components/Loader";
import { Button } from "ui/components/Button/Button";

// Moduli specifični za projekt
import { Routes } from "ui/modules/navigation";
import TabMenu from "./components/TabMenu/TabMenu";
import TenantDetailCard from "./components/TenantDetailCard/TenantDetailCard";
import TenantEditCard from "ui/modules/tenants/pages/TenantsSearchPage/components/TenantEditCard/TenantEditCard";

const TenantDetailPage: TenantDetailPageCmp = (
  _props: TenantDetailPageProps
) => {
  const { tenantId } = useParams<{ tenantId: string }>();

  const [tenant, setTenant] = useState<Tenant>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [showEditModal, setShowEditModal] = useState<boolean>(false);

  const fetchTenant = useCallback(async () => {
    if (!tenantId) return;
    setIsLoading(true);
    try {
      setTenant(await getTenantAPI(tenantId));
    } catch {
      // error handled by snackbar
    }
    setIsLoading(false);
  }, [tenantId]);

  useEffect(() => {
    fetchTenant();
  }, [fetchTenant]);

  const title = TENANT_DETAIL_PAGE_TITLE;

  const breadcrumbs: BreadcrumbItem[] = [
    {
      text: TENANT_SEARCH_PAGE_TITLE.text,
      route: TENANT_SEARCH_PAGE_TITLE.route,
    },
  ];

  const tenantName = tenant
    ? tenant.companyName ||
    [tenant.firstName, tenant.lastName].filter(Boolean).join(" ")
    : "";

  const handleEditClick = useCallback(() => {
    setShowEditModal(true);
  }, []);

  const handleEditSuccess = useCallback(() => {
    setShowEditModal(false);
    fetchTenant();
  }, [fetchTenant]);

  const handleEditClose = useCallback(() => {
    setShowEditModal(false);
  }, []);

  if (!tenantId) return <></>;

  return (
    <>
      <div className="">
        <div className="bg-white rounded-t-md">
          <PageHeader>
            <div className="flex justify-between">
              <div>
                <PageTitle
                  title={tenantName ? `${title.text} [${tenantName}]` : title.text}
                  icon={title.icon}
                  iconColor={title.iconColor}
                />
                <Breadcrumb items={breadcrumbs} />
              </div>
              <div className="flex gap-2 items-center">
                <Button
                  variant="primary"
                  startIcon="/media/icons/plus.svg"
                  children="Promjeni"
                  onClick={handleEditClick}
                />
              </div>
            </div>
          </PageHeader>
          <TabMenu tenantId={tenantId} />
        </div>
        <div className="px-4 py-4">
          {isLoading || !tenant ? (
            <Loader isLoading={true}> </Loader>
          ) : (
            <TenantDetailCard tenant={tenant} onRefresh={fetchTenant} />
          )}
        </div>
      </div>

      <TenantEditCard
        tenantId={tenantId}
        show={showEditModal}
        onSuccess={handleEditSuccess}
        onClose={handleEditClose}
   
      />
    </>
  );
};

TenantDetailPage.route = Routes.TenantDetailPageRouter;

export default TenantDetailPage;
